import { defaultRangeExtractor } from '@tanstack/react-virtual'
import { type Range } from '@tanstack/virtual-core'
import { useCallback, useRef } from 'react'

export const useKeepMountedRangeExtractor = () => {
	const renderedRef = useRef(new Set<number>())

	const rangeExtractor = useCallback((range: Range) => {
		renderedRef.current = new Set([...renderedRef.current, ...defaultRangeExtractor(range)])
		return Array.from(renderedRef.current) as number[]
	}, [])

	return rangeExtractor
}
